import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <div data-testid="privacy-policy-page">
      {/* Hero Section */}
      <section className="relative bg-[#0F172A] pt-32 pb-16 noise-overlay">
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12">
          <h1 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-white mb-4">
            Privacy Policy
          </h1>
          <p className="text-slate-400">Last updated: March 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 prose prose-slate max-w-none">
          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">1. Introduction</h2>
          <p className="text-slate-600 mb-4">
            Supply Hub ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
          </p>
          <p className="text-slate-600 mb-4">
            Our company is registered in Belgium at: Silversquare, 523 Avenue Louise, 1050 Bruxelles, Belgique.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">2. Information We Collect</h2>
          <p className="text-slate-600 mb-4">We collect information you provide directly to us, including:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4">
            <li>Name and company name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Message content from quote requests</li>
          </ul>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">3. How We Use Your Information</h2>
          <p className="text-slate-600 mb-4">We use the information we collect to:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4">
            <li>Respond to your inquiries and quote requests</li>
            <li>Provide our procurement and sourcing services</li>
            <li>Send you relevant information about our services</li>
            <li>Improve our website and services</li>
          </ul>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">4. Data Protection</h2>
          <p className="text-slate-600 mb-4">
            We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">5. Your Rights</h2>
          <p className="text-slate-600 mb-4">Under GDPR, you have the right to:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4">
            <li>Access your personal data</li>
            <li>Rectify inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to processing of your data</li>
            <li>Data portability</li>
          </ul>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">6. Contact Us</h2>
          <p className="text-slate-600 mb-4">
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="text-slate-600 mb-4">
            Email: <a href="mailto:jemimabolokwa@supply-hub.eu" className="text-[#0EA5E9]">jemimabolokwa@supply-hub.eu</a><br />
            Phone: +32 496 79 64 61<br />
            Address: Silversquare, 523 Avenue Louise, 1050 Bruxelles, Belgique
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
